const dateFormat = {
    EventDetailDateFormat: "DD MMMM, YYYY",
    HomePageDateFormat: "DD MMMM, YYYY", 
    timeFormat12: 'LT',
    fullDateFormat: "DD MMM, YYYY",
    fullMonthWithYear: 'MMMM, YYYY',
    DayOfWeek: "dddd, DD YYYY",
    Day: 'DD',
    ReportDateFormat: "DD/MM/YYYY",
}

export default dateFormat;